
import { useState } from 'react';
import '../Assets/Css/maintenance.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaHardHat, FaCog, FaGraduationCap, FaCalendarAlt, FaBriefcase } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import aboutsecurity from '../Assets/Image/maintenaceabout.avif'


 
import ctasecureimg from '../Assets/Image/maintenancecta.jpg';
import { Helmet } from 'react-helmet';

import mepmaintence from 	'../Assets/Image/General Maintenance1.avif' 
import factorymaintenance from '../Assets/Image/FactoryMachinery1.avif' 
import liftmaintenance from  '../Assets/Image/Lift Installation Maintenance1.avif'
import ifmservices from '../Assets/Image/Integrated Facility Management1.avif'

import mep1 from '../Assets/Image/General Maintenance2.avif'
import mep2 from '../Assets/Image/General Maintenance3.avif'
import mep3 from '../Assets/Image/General Maintenance4.avif'

import factory1 from '../Assets/Image/FactoryMachinery2.jpg'
import factory2 from '../Assets/Image/FactoryMachinery3.jpg'
import factory3 from '../Assets/Image/FactoryMachinery4.avif'

import lift1 from '../Assets/Image/Lift Installation Maintenance2.avif'
import lift2 from '../Assets/Image/Lift Installation Maintenance3.avif'
import lift3 from '../Assets/Image/Lift Installation Maintenance5.avif'

import ifm1 from '../Assets/Image/Integrated Facility Management2.avif'
import ifm2 from '../Assets/Image/Integrated Facility Management3.avif'
import ifm3 from '../Assets/Image/Integrated Facility Management4.avif'
 


export default function MaintenanceServices() {
 const testimonials = [
  {
    message: "Their MEP maintenance service has drastically reduced our downtime and improved overall efficiency. Truly reliable!",
    author: "Facilities Manager",
  },
  {
    message: "We’ve relied on their team for lift maintenance across our residential towers — always prompt, professional, and proactive.",
    author: "Operations Head",
  },
  {
    message: "Factory machinery maintenance was handled with expertise. Our production line is smoother than ever.",
    author: "Plant Manager",
  },
  {
    message: "Their integrated facility management approach is cost-effective and simplified our building operations. One-stop solution!",
    author: "Admin Director",
  },
];


const maintenanceServices = [
  {
    id: 1,
    title: "General Maintenance (MEP)",
    description: `We specialize in Mechanical, Electrical, and Plumbing (MEP) systems maintenance to ensure peak functionality and safety. Our certified technicians handle HVAC servicing, electrical inspections, plumbing repairs, fire systems checks, and lighting maintenance. We conduct scheduled checks, proactively identify faults, and ensure energy-efficient operations while meeting compliance and safety norms.`,
    howItWorks: `Our team conducts comprehensive inspections and preventive maintenance using diagnostic tools to detect issues early. All MEP systems are tested against industry benchmarks, and repairs or optimizations are performed to prevent future failures.`,
    benefits: [
      "Reduces unexpected breakdowns",
      "Ensures regulatory compliance",
      "Extends system life",
      "Improves energy efficiency",
      "Minimizes long-term costs",
    ],
    usedIn: [
      "Commercial buildings",
      "Industrial plants",
      "Residential complexes",
      "Educational institutions",
    ],
    image: mepmaintence,
    alt: "MEP Maintenance",
    relatedImages: [mep1, mep2, mep3],
  },
  {
    id: 2,
    title: "Factory & Machinery General Maintenance",
    description: `We provide full-spectrum maintenance services for industrial machinery and factory infrastructure. This includes preventive, predictive, and breakdown maintenance to ensure operational continuity. Our experienced technicians handle heavy-duty equipment like compressors, conveyors, production lines, and utility systems.`,
    howItWorks: `We implement routine inspections, predictive analytics, lubrication schedules, and emergency fixes. Maintenance logs are tracked to predict failures and improve uptime. Components are tested and replaced before they can impact production.`,
    benefits: [
      "Minimizes downtime and delays",
      "Increases machinery lifespan",
      "Improves workplace safety",
      "Boosts production efficiency",
      "Reduces maintenance costs over time",
    ],
    usedIn: [
      "Manufacturing units",
      "Processing plants",
      "Warehouses",
      "Logistics hubs",
    ],
    image: factorymaintenance,
    alt: "Factory Maintenance",
    relatedImages: [factory1, factory2, factory3],
  },
  {
    id: 3,
    title: "Lift Installation & Maintenance",
    description: `We offer complete elevator and lift services — including installation, modernization, AMC (Annual Maintenance Contracts), and safety inspections. Our work covers passenger lifts, service lifts, and hospital elevators in both commercial and residential setups.`,
    howItWorks: `Our technicians follow OEM guidelines and safety codes to ensure proper functioning. This includes real-time inspections, lubrication, replacing worn-out parts, and emergency call response. We also upgrade older systems with smart controls and safety sensors.`,
    benefits: [
      "Smooth and safe lift operations",
      "Prevents costly breakdowns",
      "Ensures legal compliance and certifications",
      "Reduces passenger risk",
      "24/7 emergency support",
    ],
    usedIn: [
      "Apartments",
      "Shopping malls",
      "Hospitals",
      "Hotels",
      "Corporate offices",
    ],
    image: liftmaintenance,
    alt: "Lift Maintenance",
    relatedImages: [lift1, lift2, lift3],
  },
  {
    id: 4,
    title: "Integrated Facility Management (IFM)",
    description: `Our Integrated Facility Management (IFM) combines multiple essential services — such as technical maintenance, housekeeping, security, gardening, pest control, and administration — into a unified and streamlined model. This reduces vendor dependencies and simplifies operational oversight.`,
    howItWorks: `We deploy centralized monitoring platforms, trained multi-skilled staff, and facility supervisors to deliver consistent performance. A dedicated account manager ensures smooth coordination, while KPIs are monitored in real time to ensure quality and cost control.`,
    benefits: [
      "Single point of accountability",
      "Streamlined vendor and resource management",
      "Scalable to any property size",
      "Significant operational cost savings",
      "Improved compliance and response time",
    ],
    usedIn: [
      "Corporate campuses",
      "IT parks",
      "Government offices",
      "Hospitals",
      "Educational institutions",
    ],
    image: ifmservices,
    alt: "IFM Services",
    relatedImages: [ifm1, ifm2, ifm3],
  },
];


 

 const [selectedService, setSelectedService] = useState(maintenanceServices[0]);

  return (
    <div className="mainnav min-vh-100">

     <Helmet>
        {/* Basic SEO */}
        <title>Maintenance Services | MEP, Machinery & Facility Solutions - Pradh</title>
        <meta
          name="description"
          content="Comprehensive maintenance services by Pradh including MEP systems, lift installations, factory machinery, and IFM for industrial, commercial, and residential sectors."
        />
        <meta
          name="keywords"
          content="MEP maintenance India, Factory maintenance, Lift service, Integrated Facility Management, HVAC servicing, Electrical inspection, Pradh Management Solutions"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Expert Maintenance Services | Pradh Management Solutions" />
        <meta
          property="og:description"
          content="Reliable maintenance services for MEP systems, machinery, lifts, and entire facilities. Delivered by trained experts across residential, industrial, and commercial sectors."
        />
        <meta property="og:url" content="https://pradh.com/maintenance-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://pradh.com/images/maintenance-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Maintenance Services | Pradh Management Solutions" />
        <meta
          name="twitter:description"
          content="Trusted provider of preventive and general maintenance for MEP systems, machinery, and facilities across sectors. Safe, efficient, and professional."
        />
        <meta name="twitter:image" content="https://pradh.com/images/maintenance-banner.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://pradh.com/maintenance-services" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section4">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1  data-aos="zoom-in" >Expert Maintenance <br /> Services</h1>
          <p  data-aos="zoom-in" data-aos-delay="100">Comprehensive MEP, Machinery, and Facility Maintenance for Residential, Commercial, and Industrial Spaces</p>
          <a href="/contact" className="btn-get mt-3"  data-aos="fade-up" data-aos-delay="200">Get in Touch</a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
  <Container>
    <Row>
      <Col md={5} className="d-flex justify-content-center align-items-center">
        <img
          src={aboutsecurity}
          alt="Maintenance Overview"
          className="img-fluid aboutsecimg rounded shadow mb-3"
          data-aos="zoom-in"
          data-aos-delay="100"
        />
      </Col>
      <Col md={7}>
        <h2 className="page-title text-center" data-aos="fade-up">
          Overview
        </h2>
        <p data-aos="zoom-in" data-aos-delay="100">
          At <strong style={{ color: '#04A1D3' }}>Pradh Management Solutions</strong>, our Maintenance Services ensure smooth operations across residential, commercial, and industrial sectors. From MEP systems and machinery to lift maintenance and full-scale IFM services, we deliver safety, efficiency, and reliability through expert care and regular servicing.
        </p>
        <p data-aos="zoom-in" data-aos-delay="100">
          We focus on minimizing downtime, optimizing equipment lifespan, and enhancing facility performance. Our experienced technicians are equipped with the latest tools and comply with international standards to ensure seamless and sustainable maintenance solutions.
        </p>
      </Col>
    </Row>
  </Container>
</section>


     
      

     <section className="services-description py-5 bg-light">
  <Container>
  <h2 className="page-title text-center" data-aos="fade-up">
    Our Maintenance Service Offerings
    </h2>
    <Row className="gx-4 gy-4">
      {maintenanceServices.map((service) => (
        <Col md={3} sm={6} xs={12} key={service.id}>
          <div className="service-cardmain text-center p-3 rounded shadow-sm h-100">
            <div className="image-wrapper mb-3">
              <img
                src={service.image}
                className="img-fluid maintenanceserviceimage"
                alt={service.alt}
              />
            </div>
            <h6 className="service-title">{service.title}</h6>
          </div>
        </Col>
      ))}
    </Row>
  </Container>
</section>


<section className="py-5 bg-white">
  <Container>
    <h2 className="text-center mb-5 page-title" data-aos="fade-up">
      Explore Our Maintenance Services
    </h2>
    <Row>
      <Col md={11} className="mx-auto">
        <Row className="gy-3 gy-md-0 gx-0" >
          <Col md={3} className="left-column-bg ">
            <div className="list-group">
              {maintenanceServices.map((service) => (
                <div
                  key={service.id}
                  onClick={() => setSelectedService(service)}
                  className={`list-group-item list-group-item-action mb-2 ${
                    selectedService.id === service.id ? "active-service" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                >
                  {service.title}
                </div>
              ))}
            </div>
          </Col>

          <Col md={9}>
            <div className="p-4 border rounded shadow-lg bg-white">
              <h4 className="mb-3 text-center" style={{ color: '#EE6602' }}>
                {selectedService.title}
              </h4>
              <img
                src={selectedService.image}
                alt={selectedService.alt}
                className="img-fluid rounded mb-3"
                style={{ maxHeight: "300px", objectFit: "fill", width: "100%" }}
              />
              <p className="px-3">{selectedService.description}</p>
              {selectedService.howItWorks && <p className="px-3">{selectedService.howItWorks}</p>}

              <Row className="mt-4">
                <Col md={6} className="px-3">
                  <p><strong>Benefits:</strong></p>
                  <ul>
                    {selectedService.benefits.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </Col>
                <Col md={6}>
                  <p><strong>Application Areas:</strong></p>
                  <ul>
                    {selectedService.usedIn.map((area, i) => (
                      <li key={i}>{area}</li>
                    ))}
                  </ul>
                </Col>
              </Row>

              {selectedService.relatedImages && (
                <Row className="gy-3 mt-3">
                  {selectedService.relatedImages.map((img, index) => (
                    <Col md={4} sm={6} xs={12} key={index}>
                      <img
                        src={img}
                        alt={`Related ${index + 1}`}
                        className="img-fluid rounded related-image"
                      />
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </Container>
</section>



      {/* Contact CTA Section */}
      <section className="contact-cta  py-4 text-center">
        <Container>
          <Row className="align-items-center">
             <Col md={6} className="text-center text-md-start mb-3"  data-aos="zoom-in" data-aos-delay="100">
              <h2>Ready to Keep Your Facility Running Smoothly?</h2>
              <p className="lead">
              Connect with our maintenance experts for reliable and efficient services tailored to your needs.
              </p>
              <a href="/contact" className="btn-get">Request a Consultation</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={ctasecureimg}
                  alt="Professional service team at work"
                  className="img-fluid  rounded shadow"
                   data-aos="zoom-in" data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center"  data-aos="fade-up" >What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>
                        “{testimonial.message}”
                      </p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
